import { _api } from "../../api/Api";
export const SET_CITIES = 'SET_CITIES';
export const SET_BANKS = 'SET_BANKS';
export const SET_BANK_LABELS = 'SET_BANK_LABELS';
export const SET_VARIANTS = 'SET_VARIANTS';
export const SET_DEALERS = 'SET_DEALERS';
export const SET_SALESPERSONS = 'SET_SALESPERSONS';
export const SET_CORPORATECLIENTS = 'SET_CORPORATECLIENTS';
export const SET_SOURCE = 'SET_SOURCE';
export const SET_MAKE = 'SET_MAKE';
export const SET_MODEL = 'SET_MODEL';
export const SET_PARTS_VARIANT = 'SET_PARTS_VARIANT';
export const SET_PARTS_COLORS = 'SET_PARTS_COLORS';
export const SET_CATEGORY = 'SET_CATEGORY';
export const SET_VENDOR = 'SET_VENDOR';
export const SET_TAX = 'SET_TAX';
export const SET_DISCOUNT = 'SET_DISCOUNT';
export const SET_VEHCILESBYMAKE = 'SET_VEHCILESBYMAKE';
export const SET_ALL_VEHICLES = 'SET_ALL_VEHICLES';
export const SET_ALL_TRANSPORTER = 'SET_ALL_TRANSPORTER';
export const SET_ALL_DEPARTMENTS = 'SET_ALL_DEPARTMENTS';

export const SET_CURRENTUSER = 'SET_CURRENTUSER';
export const SET_USERPERMISSIONS = 'SET_USERPERMISSIONS';

export const fetchCities = () => {
  return (dispatch) => {
    _api('GET', `City/active-cities`, null, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.id,
          label: item.city,
        }));
        dispatch({ type: SET_CITIES, payload: options });
      }
    });
  };
};

export const fetchBanks = () => {
  return (dispatch) => {
    _api('GET', `Banks`, null, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.id,
          label: item.bankname,
        }));
        const labels = res.data.map((item) => ({
          value: item.bankname,
          label: item.bankname,
        }));
        dispatch({ type: SET_BANKS, payload: options });
        dispatch({ type: SET_BANK_LABELS, payload: labels });
      }
    });
  };
};

export const fetchVariants = () => {
  return (dispatch) => {
    _api('GET', `Variant/get-variant/0`, null, (res) => {
      //debugger
      if (res.isSuccess) {
        const options = res.data.map(item => ({
          value: item.id,
          label: item.variant,
          makeId: item.makeId,
          makeName: item.makeName
        }));
        dispatch({ type: SET_VARIANTS, payload: options });
      }
    });
  };
};

export const fetchDealers = () => {
  return (dispatch) => {
    _api('GET', `Dealer/getAll-dealers-list?Id=0`, null, (res) => {
      if (res.isSuccess) {
        const options = res.data.map(item => ({
          value: item.id,
          label: item.dealername,
          code: item.dealercode,
        }));
        dispatch({ type: SET_DEALERS, payload: options });
      }
    });
  };
};

export const fetchSalesPersons = () => {
  return (dispatch) => {
    _api('GET', `Users/active-users-with-groups`, null, (res) => {
      if (res.isSuccess) {
        const options = res.data.map(item => ({
          value: item.id,
          label: item.fullname,
        }));
        dispatch({ type: SET_SALESPERSONS, payload: options });
      }
    });
  };
};

export const fetchCorporateClients = () => {
  return (dispatch) => {
    _api("GET", `Lead/getActiveCorporateClients`, null, (res) => {
      if (res.isSuccess) {
        if (res.data.length > 0) {
          const options = res.data.map((item) => ({
            value: item["id"],
            label: item["companyname"],
          }));
          dispatch({ type: SET_CORPORATECLIENTS, payload: options });
        }
      }
    });
  }
};

export const fetchSource = () => {
  return (dispatch) => {
    _api("GET", `Source/get-sources/0`, null, (res) => {
      if (res.isSuccess) {
        if (res.data.length > 0) {
          const options = res.data.map((item) => ({
            value: item["id"],
            label: item["source"],
          }));
          dispatch({ type: SET_SOURCE, payload: options });
        }
      }
    });
  }
};

export const fetchMake = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-makes", { makeId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.makeId,
          label: item.makeName,
        }));
        dispatch({ type: SET_MAKE, payload: options });
      }
    });
  };
};

export const fetchModel = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-models", { modelId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.modelId,
          label: item.modelName,
          makeId: item.makeId
        }));
        dispatch({ type: SET_MODEL, payload: options });
      }
    });
  };
};

export const fetchPartsVariant = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-part-variants", { variantId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.variantId,
          label: item.variantName,
          modelId: item.modelId,
          makeId: item.makeId
        }));
        dispatch({ type: SET_PARTS_VARIANT, payload: options });
      }
    });
  };
};

export const fetchPartsColors = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-colors", { colorId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.colorId,
          label: item.colorName,
          variantId: item.variantId,
          modelId: item.modelId,
          makeId: item.makeId
        }));
        dispatch({ type: SET_PARTS_COLORS, payload: options });
      }
    });
  };
};

export const fetchPartsCategory = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-categories", { categoryId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.categoryId,
          label: item.categoryName,
        }));
        dispatch({ type: SET_CATEGORY, payload: options });
      }
    });
  };
};

export const fetchVendors = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-vendor", { vendorId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.vendorId,
          label: item.vendorCode + "-" + item?.vendorName,
          vendor: item
          // label: item.vendorName + "-" + item?.phone,
        }));
        dispatch({ type: SET_VENDOR, payload: options });
      }
    });
  };
};

export const fetchTax = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-partTax", { taxId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.taxId,
          label: item.taxName + " " + item?.taxPercentage + "%",
          taxValue: item?.taxPercentage
        }));
        dispatch({ type: SET_TAX, payload: options });
      }
    });
  };
};

export const fetchDiscount = () => {
  return (dispatch) => {
    _api("POST", "Parts/get-discountGroups", { discountGroupId: 0 }, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.discountGroupId,
          label: item.discountGroupName + " " + item?.discountPercentage + "%",
          discountValue: item?.discountPercentage
        }));
        dispatch({ type: SET_DISCOUNT, payload: options });
      }
    });
  };
};

export const fetchTransporter = () => {
  return (dispatch) => {
    _api("GET", `Stock/getTransporter?id=${0}`, null, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.name,
          label: item.code + " " + item?.name,
          transporter: item
        }));
        dispatch({ type: SET_ALL_TRANSPORTER, payload: options });
      }
    });
  };
};

export const fetchVehiclecByMake = () => {
  return (dispatch) => {
    _api("GET", "Vehicle/grouped-by-make", null, (res) => {
      if (res.isSuccess) {
        // Grouped wise make > vehciles
        const options = res.data.map((item) => ({
          value: item.makeId,
          label: item.makeName,
          vehicles: item?.makeGroup
        }));

                 // Sare Vehiciles flat
                const vehicleOptions = res.data.flatMap((item) =>
                (item.makeGroup || []).map((v) => ({
                  value: v.id,
                  variantId: v.variantId,
                  label: [
                    `${item?.makeName} ${v?.variant}`, v?.year && `(${v?.year})`, v?.transmission, v?.fuelType, v?.engineType, v?.generation, v?.colour
                  ].filter(Boolean).join(" ")
                }))
              );
              dispatch({ type: SET_VEHCILESBYMAKE, payload: options });
              dispatch({ type: SET_ALL_VEHICLES, payload: vehicleOptions });

      }
    });
  };
};

export const fetchDepartments = () => {
  return (dispatch) => {
    _api("GET", 'Department/GetAllDepartment', null, (res) => {
      if (res.isSuccess) {
        const options = res.data.map((item) => ({
          value: item.id,
          label: item.departmentCode + " — " + item?.departmentName,
        }));
        dispatch({ type: SET_ALL_DEPARTMENTS, payload: options });
      }
    });
  };
};

// actions.js
export const RESET_STORE = "RESET_STORE";
export const loadMasterData = () => (dispatch) => {
  dispatch(fetchCities());
  dispatch(fetchBanks());
  dispatch(fetchDealers());
  dispatch(fetchSalesPersons());
  dispatch(fetchVariants());
  dispatch(fetchCorporateClients());
  dispatch(fetchSource());
  dispatch(fetchMake());
  dispatch(fetchModel());
  dispatch(fetchPartsVariant());
  dispatch(fetchPartsColors());
  dispatch(fetchPartsCategory());
  dispatch(fetchVendors());
  dispatch(fetchTax());
  dispatch(fetchDiscount());
  dispatch(fetchVehiclecByMake());
  dispatch(fetchTransporter());
  dispatch(fetchDepartments());
};

const user = JSON.parse(localStorage.getItem("permissions"));
export const activeUser = () => ({
    type: "SET_CURRENTUSER",
    payload: user,
  });

const user_per = JSON.parse(localStorage.getItem("permissionsMap"));
export const userPermissions = () => ({
  type: "SET_USERPERMISSIONS",
  payload: user_per,
});



export const product_list = () => ({ type: "Product_list" });
export const set_product_list = (payload) => ({
  type: "Product_list",
  payload,
});

export const dashboard_recentproduct = () => ({
  type: "Dashbaord_RecentProduct",
});
export const setdashboard_recentproduct = (payload) => ({
  type: "Dashbaord_RecentProduct",
  payload,
});
export const dashboard_expiredproduct = () => ({
  type: "Dashbaord_ExpiredProduct",
});
export const setdashboard_expiredproduct = (payload) => ({
  type: "Dashbaord_ExpiredProduct",
  payload,
});
export const saleshdashboard_recenttransaction = () => ({
  type: "Salesdashbaord_ExpiredProduct",
});
export const setsaleshdashboard_recenttransaction = (payload) => ({
  type: "Salesdashbaord_ExpiredProduct",
  payload,
});
export const brand_list = () => ({ type: "Brand_list" });
export const setbrand_list = (payload) => ({
  type: "Brand_list",
  payload,
});
export const unit_data = () => ({ type: "Unit_Data" });
export const setunit_data = (payload) => ({
  type: "Unit_Data",
  payload,
});
export const variantattributes_data = () => ({ type: "Variantattribute_Data" });
export const setvariantattributes_data = (payload) => ({
  type: "Variantattribute_Data",
  payload,
});
export const warranty_data = () => ({ type: "Warranty_Data" });
export const setwarranty_data = (payload) => ({
  type: "Warranty_Data",
  payload,
});
export const barcode_data = () => ({ type: "Barcode_Data" });
export const setbarcode_data = (payload) => ({
  type: "Barcode_Data",
  payload,
});
export const departmentlist_data = () => ({ type: "Department_Data" });
export const setdepartmentlist_data = (payload) => ({
  type: "Department_Data",
  payload,
});
export const designation_data = () => ({ type: "Designation_Data" });
export const setdesignation_data = (payload) => ({
  type: "Designation_Data",
  payload,
});
export const shiftlist_data = () => ({ type: "Shiftlist_Data" });
export const setshiftlist_data = (payload) => ({
  type: "Shiftlist_Data",
  payload,
});
export const attendenceemployee_data = () => ({
  type: "Attendenceemployee_Data",
});
export const setattendenceemployee_data = (payload) => ({
  type: "Attendenceemployee_Data",
  payload,
});
export const toogleHeader_data = () => ({ type: "toggle_header" });
export const setToogleHeader = (payload) => ({
  type: "toggle_header",
  payload,
});
export const invoicereport_data = () => ({ type: "Invoicereport_Data" });
export const setinvoicereport_data = (payload) => ({
  type: "Invoicereport_Data",
  payload,
});
export const salesreturns_data = () => ({ type: "Salesreturns_Data" });
export const setsalesreturns_data = (payload) => ({
  type: "Salesreturns_Data",
  payload,
});
export const quotationlist_data = () => ({ type: "Quatation_Data" });
export const setquotationlist_data = (payload) => ({
  type: "Quatation_Data",
  payload,
});
export const customer_data = () => ({ type: "customer_data" });
export const setcustomer_data = (payload) => ({
  type: "customer_data",
  payload,
});
export const userlist_data = () => ({ type: "Userlist_data" });
export const setuserlist_data = (payload) => ({
  type: "Userlist_data",
  payload,
});
export const rolesandpermission_data = () => ({
  type: "Rolesandpermission_data",
});
export const setrolesandpermission_data = (payload) => ({
  type: "Rolesandpermission_data",
  payload,
});
export const deleteaccount_data = () => ({ type: "Deleteaccount_data" });
export const setdeleteaccount_data = (payload) => ({
  type: "Deleteaccount_data",
  payload,
});
export const attendanceadmin_data = () => ({ type: "Attendenceadmin_data" });
export const setattendanceadmin_data = (payload) => ({
  type: "Attendenceadmin_data",
  payload,
});
export const leavesadmin_data = () => ({ type: "Leavesadmin_data" });
export const setleavesadmin_data = (payload) => ({
  type: "Leavesadmin_data",
  payload,
});
export const leavetypes_data = () => ({ type: "Leavestype_data" });
export const setleavetypes_data = (payload) => ({
  type: "Leavestype_data",
  payload,
});
export const holiday_data = () => ({ type: "Holiday_data" });
export const setholiday_data = (payload) => ({
  type: "Holiday_data",
  payload,
});
export const expiredproduct_data = () => ({ type: "Expiredproduct_data" });
export const setexpiredproduct_data = (payload) => ({
  type: "Expiredproduct_data",
  payload,
});
export const lowstock_data = () => ({ type: "Lowstock_data" });
export const setlowstock_data = (payload) => ({
  type: "Lowstock_data",
  payload,
});
export const categotylist_data = () => ({ type: "Categotylist_data" });
export const setcategotylist_data = (payload) => ({
  type: "Categotylist_data",
  payload,
});
export const setLayoutChange = (payload) => ({
  type: "Layoutstyle_data",
  payload,
});